import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=48a01534&"
import script from "./VoteList.vue?vue&type=script&lang=js&"
export * from "./VoteList.vue?vue&type=script&lang=js&"
import style0 from "./VoteList.vue?vue&type=style&index=0&id=48a01534&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports